/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule }     from '@angular/core';
import { RouterModule } from '@angular/router';

import { editRoute, newRoute, detailRoute } from "../../shared/services/data.service";
import { OrdemServicoListComponent } from "./ordem-servico-list/ordem-servico-list.component";
import { OrdemServicosFormComponent } from "./ordem-servico-form/ordem-servico-form.component";
import { OrdemServicoDetailComponent } from "./ordem-servico-detail/ordem-servico-detail.component";
import { OrdemServicoItemFormComponent } from "./ordem-servico-item/ordem-servico-item-form/ordem-servico-item-form.component";
import { ordensServicoItemsServicoRoute, ordensServicoItemsMaterialRoute } from "./shared/data.service";
import { OrdemServicoCalendarComponent } from "./ordem-servico-calendar/ordem-servico-calendar.component";

@NgModule({
    imports: [
        RouterModule.forChild([])
    ],
    exports: [
        RouterModule
    ]
})
export class OrdensServicoRoutingModule {}

export const ordensServicoRoutes: any[] = [
    {
        path: '',
        component: OrdemServicoListComponent
    },{
        path: editRoute + '/:id',
        component: OrdemServicosFormComponent
    },{
        path: newRoute,
        component: OrdemServicosFormComponent
    },{
        path: detailRoute + '/:id',
        component: OrdemServicoDetailComponent
    },{
        path: ordensServicoItemsServicoRoute + '/' + editRoute + '/:osId/:tipo/:id',
        component: OrdemServicoItemFormComponent
    },{
        path: ordensServicoItemsServicoRoute + '/' + newRoute + '/:osId/:tipo',
        component: OrdemServicoItemFormComponent
    },{
        path: ordensServicoItemsMaterialRoute + '/' + editRoute + '/:osId/:tipo/:id',
        component: OrdemServicoItemFormComponent
    },{
        path: ordensServicoItemsMaterialRoute + '/' + newRoute + '/:osId/:tipo',
        component: OrdemServicoItemFormComponent
    },{
        path: 'agenda',
        component: OrdemServicoCalendarComponent
    }
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/ordens-servico/ordens-servico-routing.module.ts
 **/